import { AlertCircleIcon, CheckCircle2Icon, CircleDotIcon } from 'lucide-react';
import type { Check } from '../editing';

/** "Wat mist er nog?" — rood blokkeert de site, oranje is een aanrader. */
export function CheckList({
  checks,
  okText = 'Alles is ingevuld'
}: {
  checks: Check[];
  okText?: string;
}) {
  if (checks.length === 0) {
    return <p className="flex items-center gap-2 text-[13px] text-sage" data-id="element-4904" data-mp="o2t8k83lfsgm">
        <CheckCircle2Icon className="h-4 w-4" strokeWidth={1.75} aria-hidden="true" data-id="element-4905" data-mp="12rzgckghyr04" />
        {okText}
      </p>;
  }
  return <ul className="space-y-2" data-id="element-4906" data-mp="xsmkja7ne9le">
      {checks.map(c => <li key={c.text} className="flex items-start gap-2 text-[13px] leading-snug" data-id="element-4907" data-mp="1bsxb0c51pm61">
          {c.level === 'error' ? <AlertCircleIcon className="mt-0.5 h-4 w-4 shrink-0 text-clay" strokeWidth={1.75} aria-hidden="true" data-id="element-4908" data-mp="16v5jvkc8642w" /> : <CircleDotIcon className="mt-0.5 h-4 w-4 shrink-0 text-muted" strokeWidth={1.75} aria-hidden="true" data-id="element-4909" data-mp="3dksiefk9r4ig" />}
          <span className={c.level === 'error' ? 'text-ink' : 'text-muted'} data-id="element-4910" data-mp="12zldb6m213fs">
            <span className="sr-only" data-id="element-4911" data-mp="131eiehh0rflo">{c.level === 'error' ? 'Moet nog: ' : 'Aanrader: '}</span>
            {c.text}
          </span>
        </li>)}
    </ul>;
}